import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/caprock/front-images/user.png'
import _imports_1 from '../assets/caprock/status/active.svg'
import _imports_2 from '../assets/caprock/status/pending.svg'
import _imports_3 from '../assets/caprock/status/reject.svg'


const _hoisted_1 = { class: "main-content" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "tab-content w-100" }
const _hoisted_5 = { class: "my-4 mx-4 p-0 bg-white border-radius-10" }
const _hoisted_6 = {
  class: "row m-0 bg-card-light",
  style: {"border-radius":"10px 10px 0px 0px"}
}
const _hoisted_7 = { class: "col-md-4 d-flex justify-content-start py-4" }
const _hoisted_8 = { class: "d-flex" }
const _hoisted_9 = { class: "font-size-16 font-grey p-cursor" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"50px","height":"50px","object-fit":"cover","border-radius":"50%","margin":"0 15px 0 0"},
  onerror: "this.src='../assets/caprock/front-images/user.png';",
  src: _imports_0
}, null, -1)
const _hoisted_11 = { style: {"color":"#6B7A99"} }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-4 d-flex justify-content-center align-items-center py-4" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-4 d-flex justify-content-end align-items-center py-4" }, null, -1)
const _hoisted_14 = { class: "row my-3 justify-content-center" }
const _hoisted_15 = { class: "col-md-12 px-5 pt-4" }
const _hoisted_16 = { class: "p-4 mb-4 bg-card-light border-radius-10 h-100" }
const _hoisted_17 = { class: "row mt-3 mx-1" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-flex justify-content-between mb-2" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "font-grey font-size-14" }, [
      /*#__PURE__*/_createElementVNode("b", null, "Documents")
    ])
  ])
], -1)
const _hoisted_19 = { class: "col-6" }
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"row my-3 mx-1\"><div class=\"col-md-2\"><label class=\"font-grey mx-2\">Document ID</label></div><div class=\"col-md-2\"><label class=\"font-grey mx-2\">Status</label></div><div class=\"col-md-4\"><label class=\"font-grey mx-2\">Document Name</label></div><div class=\"col-md-3\"><label class=\"font-grey mx-2\">Date Added</label></div><div class=\"col-md-1\"><label class=\"font-grey mx-2\">Action</label></div></div>", 1)
const _hoisted_21 = {
  key: 0,
  id: "results"
}
const _hoisted_22 = { class: "col-md-2" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { class: "doc_tag" }
const _hoisted_25 = {
  key: 0,
  src: _imports_1,
  style: {"height":"1rem","margin-right":"5px","margin-top":"-2px"}
}
const _hoisted_26 = {
  key: 1,
  src: _imports_2,
  style: {"height":"1rem","margin-right":"5px","margin-top":"-2px"}
}
const _hoisted_27 = {
  key: 2,
  src: _imports_3,
  style: {"height":"1rem","margin-right":"5px","margin-top":"-2px"}
}
const _hoisted_28 = { class: "col-md-2" }
const _hoisted_29 = {
  class: "form-group doc",
  style: {"overflow":"auto"}
}
const _hoisted_30 = { class: "doc_tag" }
const _hoisted_31 = { class: "col-md-4" }
const _hoisted_32 = {
  class: "form-group",
  style: {"overflow":"auto"}
}
const _hoisted_33 = { class: "doc_tag" }
const _hoisted_34 = { class: "col-md-3" }
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = { class: "doc_tag" }
const _hoisted_37 = { class: "col-md-1" }
const _hoisted_38 = { class: "form-group text-center" }
const _hoisted_39 = ["id", "value"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", {
  style: {"font-size":"18px","color":"#005288","font-weight":"bolder","writing-mode":"vertical-rl","text-orientation":"sideways","margin-top":"15px"},
  class: "p-cursor dropdown-toggle",
  id: "datatoggle",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, " ... ", -1)
const _hoisted_41 = {
  class: "dropdown-menu",
  "aria-labelledby": "datatoggle"
}
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = {
  key: 1,
  id: "results"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("p", { class: "doc_tag text-center font-grey font-size-14" }, "No Data Found !!", -1)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", {
  class: "modal fade sending_email",
  id: "sending_email",
  role: "dialog"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "modal-dialog modal-sm modal-dialog-centered",
    role: "document"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "modal-content bg-light" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "modal-body mb-2" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "row mx-1 mt-4" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 text-center" }, [
            /*#__PURE__*/_createElementVNode("p", null, "Sending document to your mail ! Please Wait.....")
          ])
        ])
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic = _resolveComponent("basic")!
  const _component_right_side = _resolveComponent("right-side")!
  const _component_toasti = _resolveComponent("toasti")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_basic),
    _createVNode(_component_right_side, {
      user_info: _ctx.user_info,
      customer_accounts: _ctx.customer_accounts
    }, null, 8, ["user_info", "customer_accounts"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, [
                    _createElementVNode("h5", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("b", _hoisted_11, _toDisplayString(_ctx.user_info.user_name), 1)
                    ])
                  ])
                ]),
                _hoisted_12,
                _hoisted_13
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("input", {
                          onKeyup: _cache[0] || (_cache[0] = ($event: any) => {_ctx.textSearch($event);}),
                          style: {"border":"1px solid grey !important","height":"35px","float":"right","border-radius":"5px !important"},
                          type: "text",
                          id: "doc_search_input",
                          placeholder: "Search doc name here..",
                          class: "bg-white w-100 pl-3"
                        }, null, 32)
                      ])
                    ]),
                    _hoisted_20,
                    (_ctx.docs.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.docs, (doc) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: doc.doc_id,
                              class: "row my-1 mx-1 docss"
                            }, [
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, [
                                  _createElementVNode("p", _hoisted_24, [
                                    _createElementVNode("span", null, [
                                      (doc.doc_status=='Approved')
                                        ? (_openBlock(), _createElementBlock("img", _hoisted_25))
                                        : _createCommentVNode("", true),
                                      (doc.doc_status=='Pending')
                                        ? (_openBlock(), _createElementBlock("img", _hoisted_26))
                                        : _createCommentVNode("", true),
                                      (doc.doc_status=='Rejected')
                                        ? (_openBlock(), _createElementBlock("img", _hoisted_27))
                                        : _createCommentVNode("", true),
                                      _createTextVNode(" " + _toDisplayString(doc.doc_id), 1)
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("div", _hoisted_29, [
                                  _createElementVNode("p", _hoisted_30, _toDisplayString(doc.doc_status), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("div", _hoisted_32, [
                                  _createElementVNode("p", _hoisted_33, _toDisplayString(doc.doc_name), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("div", _hoisted_35, [
                                  _createElementVNode("p", _hoisted_36, _toDisplayString(doc.doc_time), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("div", _hoisted_38, [
                                  _createElementVNode("input", {
                                    id: 'URL'+doc.doc_id,
                                    type: "hidden",
                                    value: doc.doc_url
                                  }, null, 8, _hoisted_39),
                                  _hoisted_40,
                                  _createElementVNode("div", _hoisted_41, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item pl-2",
                                      onClick: ($event: any) => {_ctx.open_link(doc.doc_id);},
                                      href: "#"
                                    }, " • Download", 8, _hoisted_42),
                                    _createElementVNode("a", {
                                      class: "dropdown-item pl-2",
                                      onClick: ($event: any) => {_ctx.mail_doc(doc.ref_id,1,'doc');},
                                      href: "#"
                                    }, " • Mail", 8, _hoisted_43)
                                  ])
                                ])
                              ])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.docs.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, _hoisted_46))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _hoisted_47,
    _createVNode(_component_toasti, { ref: "toasti" }, null, 512)
  ], 64))
}